// App metadata — kept in sync with Web/Catalogue/data.js (the canonical source of truth).
// Used by tester-facing pages (Apps.jsx) to render the right icon per app.
// If a slug isn't here, fall back to a generic phone emoji.
export const APP_META = {
  "radiant": { icon: "☀", color: "#F59E0B", name: "Radiant" },
  "mise": { icon: "🥗", color: "#10B981", name: "Mise" },
  "drift": { icon: "🌙", color: "#818CF8", name: "Drift" },
  "nightwell": { icon: "🎵", color: "#A78BFA", name: "NightWell" },
  "braintrainer": { icon: "🧠", color: "#F472B6", name: "BrainTrainer" },
  "mathlens": { icon: "📐", color: "#60A5FA", name: "MathLens" },
  "linguist": { icon: "🌍", color: "#2DD4BF", name: "Linguist" },
  "notecraft": { icon: "📝", color: "#FB923C", name: "Notecraft" },
  "dailyplanner": { icon: "📅", color: "#38BDF8", name: "DailyPlanner" },
  "docuflow": { icon: "📄", color: "#F87171", name: "DocuFlow" },
  "prosuite": { icon: "⚡", color: "#C084FC", name: "ProSuite" },
  "velkravoice": { icon: "🎙", color: "#E879F9", name: "VelkraVoice" },
  "clipforge": { icon: "🎬", color: "#FB7185", name: "ClipForge" },
  "prophotoeditor": { icon: "📸", color: "#D946EF", name: "ProPhotoEditor" },
  "cardtap": { icon: "💳", color: "#6366F1", name: "CardTap" },
  "bookkeeper": { icon: "📊", color: "#34D399", name: "BookKeeper" },
  "deallens": { icon: "🏷", color: "#FBBF24", name: "DealLens" },
  "leaflens": { icon: "🌿", color: "#4ADE80", name: "LeafLens" },
  "flavorbook": { icon: "👨‍🍳", color: "#F97316", name: "FlavorBook" },
  "familybridge": { icon: "👨‍👩‍👧", color: "#22D3EE", name: "FamilyBridge" },
  "lidarmapper": { icon: "📏", color: "#7C3AED", name: "LiDARMapper" },
  "cleanerkit": { icon: "🧹", color: "#94A3B8", name: "CleanerKit" },
  "gpsareameasure": { icon: "🗺", color: "#22C55E", name: "GPSAreaMeasure" },
  "quicktransfer": { icon: "📤", color: "#0EA5E9", name: "QuickTransfer" },
  "radiopulse": { icon: "📻", color: "#EF4444", name: "RadioPulse" },
  "dreamwell": { icon: "😴", color: "#7C3AED", name: "DreamWell" },
  "velkrabrowse": { icon: "🧅", color: "#1E293B", name: "VelkraBrowse" },
  "talktext": { icon: "🦦", color: "#059669", name: "TalkText" },
  "snapmeter": { icon: "⚡", color: "#F59E0B", name: "SnapMeter" },
  "routeforge": { icon: "🗺️", color: "#3B82F6", name: "RouteForge" },
  "vaultkeep": { icon: "🔐", color: "#6366F1", name: "VaultKeep" },
  "habitloop": { icon: "✅", color: "#10B981", name: "HabitLoop" },
  "soundbyte": { icon: "🎵", color: "#8B5CF6", name: "SoundByte" },
  "pixelpop": { icon: "🎨", color: "#EC4899", name: "PixelPop" },
  "timecraft": { icon: "⏱️", color: "#0EA5E9", name: "TimeCraft" },
  "birdlog": { icon: "🐦", color: "#22C55E", name: "BirdLog" },
  "stepquest": { icon: "🏃", color: "#F97316", name: "StepQuest" },
  "aquatrack": { icon: "💧", color: "#06B6D4", name: "AquaTrack" },
  "calmhaven": { icon: "🧘", color: "#8B5CF6", name: "CalmHaven" },
  "cashpilot": { icon: "💰", color: "#14B8A6", name: "CashPilot" },
  "fitvault": { icon: "💪", color: "#DC2626", name: "FitVault" },
  "growlog": { icon: "🌱", color: "#84CC16", name: "GrowLog" },
  "inkboard": { icon: "✏️", color: "#1E40AF", name: "InkBoard" },
  "labnote": { icon: "🔬", color: "#0891B2", name: "LabNote" },
  "nestiq": { icon: "🏠", color: "#EAB308", name: "NestIQ" },
  "packlist": { icon: "🧳", color: "#3B82F6", name: "PackList" },
  "pawtrack": { icon: "🐾", color: "#92400E", name: "PawTrack" },
  "skyloom": { icon: "☁️", color: "#0EA5E9", name: "SkyLoom" },
  "trainforge": { icon: "🏃", color: "#F43F5E", name: "TrainForge" },
  "tuneforge": { icon: "🎵", color: "#A855F7", name: "TuneForge" },
};

export const appIcon = (slug) => APP_META[slug]?.icon || "📱";
export const appColor = (slug) => APP_META[slug]?.color || "#6c5ce7";
export const appName = (slug) => APP_META[slug]?.name || slug;
